import React from 'react';
import Spinner from 'react-spinner';

import {
  RegionalGroupSelect,
  RadioButtonGroup
} from '../Selects';
import TagTable from './Tagtable';
import AssistanceLandingSeekingCountriesLegend from './AssistanceLandingSeekingCountriesLegend';

import fetchContent from '../../helpers/backend-communication';

const AssistanceTypeOptions = [
  { label: 'Seeking', value: 'Request' },
  { label: 'Provided', value: 'Provided' },
  { label: 'Received', value: 'Received' }
];

const tableHeaderByType = {
  Request: 'request',
  Provided: 'provided',
  Received: 'received'
};

class AssistanceLandingSeekingCountries extends React.Component {
  initialAssistanceType = 'Request';
  initialRegionalgroup = 'GLOBAL';

  constructor(props) {
    super(props);

    this.state = {
      tableData: [],
      tableColumns: [],
      regionalGroup: this.initialRegionalgroup,
      assistanceType: this.initialAssistanceType,
      isLoading: false
    };

    this.handleAssistanceTypeChange = this.handleAssistanceTypeChange.bind(this);
  }

  componentDidMount() {
    this.setState({ isLoading: true });

    fetchContent('assistanceSeekers')
      .then(
        responseObject => this.onRequestComplete(responseObject.data),
        error => {
          console.error("Fetch went wrong:", error);
          this.setState({ isLoading: false });
        }
      )
  }

  onRequestComplete(data) {
    const formattedData = this.formatData(data);

    this.setState({
      tableData: formattedData,
      tableColumns: this.selectColumns(formattedData),
      isLoading: false
    });
  }

  filterStates(regionalGroup) {
    this.setState({
      regionalGroup: "GLOBAL"
    });
  }

  selectColumns(data) {
    if (data.length < 1) return [];
    //Kindadirty...Assuming that the first countryData element contains all relevant keys
    let allColumns = Object.keys(data[0]);
    const excludableColumns = ['regionalGroup', 'countryCode'];

    return allColumns.filter((item) => !excludableColumns.includes(item));
  }

  formatData(data) {
    data = data.map(this.formatForTable.bind(this));
    return this.orderData(data);
  }

  orderData(data) {
    data.sort(function (itemA, itemB) {
      const countryA = itemA.country.value.toLowerCase();
      const countryB = itemB.country.value.toLowerCase();
      if (countryA < countryB) return -1;
      if (countryA > countryB) return 1;
      return 0;
    });
    return data;
  }

  formatForTable(countryData) {
    let formattedCountryData = {};

    formattedCountryData.country = { value: countryData.attributes.country };
    formattedCountryData.countryCode = countryData.attributes.isoAlpha3;
    formattedCountryData.regionalGroup = countryData.attributes.regionalGroup;

    const assistanceNeedsArray = countryData.attributes.assistanceNeeds;
    for (let assistanceUnit of assistanceNeedsArray) {
      const newKey = assistanceUnit.attributes.abbreviation;

      formattedCountryData[newKey] = {};
      formattedCountryData[newKey].value = assistanceUnit.attributes.value
        ? assistanceUnit.attributes.abbreviation
        : '';

      formattedCountryData[newKey].description = assistanceUnit.attributes.description;
      formattedCountryData[newKey].hasProposal = assistanceUnit.attributes.hasProposal;
      formattedCountryData[newKey].flag = assistanceUnit.attributes.flag || this.initialAssistanceType;
      formattedCountryData[newKey].proposalLink = assistanceUnit.attributes.proposalLink;
      formattedCountryData[newKey].reportSourceYear = countryData.attributes.reportSourceYear;
      formattedCountryData[newKey].reportSourceLink = countryData.attributes.reportSourceLink;
    }

    return formattedCountryData;
  }

  handleAssistanceTypeChange(assistanceType) {
    this.setState({
      assistanceType
    });
  }

  render() {
    const {
      tableData,
      tableColumns,
      regionalGroup,
      assistanceType
    } = this.state;

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-md-4">
            <div className="assistance-filter-container">
              <small>Filter by regional group</small>
              <RegionalGroupSelect
                value={ regionalGroup }
                onChange = { (selectedValue) => { this.setState({ regionalGroup: selectedValue.regionalGroup })} }
              />
            </div>
            <div className="assistance-filter-container">
              <small>Filter by assistance</small>
              <RadioButtonGroup
                name="assistance-type"
                initialChecked={ this.initialAssistanceType }
                onChange={ this.handleAssistanceTypeChange }
                options={ AssistanceTypeOptions }
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-8">
            <AssistanceLandingSeekingCountriesLegend
              thematicDict={ this.props.thematicDict }
              defaultColor={ this.props.defaultColor }
            />
          </div>
        </div>

        <h4 className="assistance-page-panel__table-header">
          Countries that { tableHeaderByType[this.state.assistanceType] } international assistance
        </h4>

        <div className="assistance-page-panel__container">
          { (this.state.isLoading)
            ? <Spinner className="assistance-page-panel__spinner" />
            : <TagTable
                className={ "table table-striped assistance-tag-table" }
                data={ tableData }
                regionalGroupFilter={ regionalGroup }
                assistanceTypeFilter={ assistanceType }
                noDataText={ "No countries found" }
                columns={ tableColumns }
                thematicDict={ this.props.thematicDict }
                defaultColor={ this.props.defaultColor }
              />
          }
        </div>
      </div>
    );
  }
}

export default AssistanceLandingSeekingCountries;



// WEBPACK FOOTER //
// ./src/components/AssistanceLanding/AssistanceLandingSeekingCountries.js